<template>
  <div class="w-full">
    <vs-button color="warning"
            icon-pack="feather"
            icon="icon-upload"
            type="filled" @click="open" class="w-full"> {{ $t('payment_file') }} </vs-button>
    <vs-popup-custom
      :title="$t('update_payment_file') | capitalize"
      color="danger"
      :buttonCloseHidden="btnCloseHidden"
      :active.sync="active"
      :persistent="true"
    >
      <div id="update-payment-file-loading" class="vs-con-loading__container">
        <vs-row vs-w="12" class="mb-2 mt-4">
          <vs-col vs-w="12">
            <vs-alert title="Aviso" color="danger" v-if="msg != ''">
              {{ msg }}
            </vs-alert>
          </vs-col>
        </vs-row>
        <vs-row vs-w="12" class="mb-2 mt-4">
          <vs-col vs-w="12">
            <qb-upload
              ref="uploadPaymentFile"
              :showUploadButton="false"
              @on-delete="handleFileDelete"
              @update-file="handleFileUpload"
              :limit="1"
              accept="image/png,image/jpeg,application/pdf"
              v-if="active"
            />
          </vs-col>
        </vs-row>
        <vs-row vs-w="12" vs-type="flex" vs-justify="center" class="mb-2 mt-4">
          <vs-col vs-w="2">
            <vs-button
              color="primary"
              type="filled"
              class="mr-6"
              @click="handleSubmit"
              :disabled="disabledSubmit"
            >
              {{ $t('update') | capitalize }}
            </vs-button>
          </vs-col>
        </vs-row>
      </div>
    </vs-popup-custom>
  </div>
</template>

<script>
import VsPopupCustom from '@/views/components/modals/VsPopupCustom.vue'
import QbUpload from '@/components/upload/QbUpload.vue'
import loading from '@/mixins/Loading'
import expense from '@/http/requests/expense'
export default {
  components: {
    VsPopupCustom,
    QbUpload
  },
  computed:{
    disabledSubmit(){
      return this.file.data === ''
    }
  },
  data() {
    return {
      active: false,
      file: {
        data: '',
        name: ''
      },
      msg: '',
      btnCloseHidden: false
    }
  },
  methods: {
    open () {
      this.file = {
        data: '',
        name: ''
      }
      this.active = true
    },
    handleFileDelete (e) {
      this.file = {
        data: '',
        name: ''
      }
    },
    handleFileUpload (e) {
      this.msg = ''
      for (let i = 0; i < e.length; i++) {
        this.file.data = e[i]
        console.log(this.file)
      }
    },
    handleSubmit () {
      this.openLoading('update-payment-file-loading')
      this.btnCloseHidden = true
      let form = new FormData()
      form.append('expense_id',this.expense)
      form.append('file',this.file.data)
      expense.updatePaymentFile(form)
      .then( res => {
        console.log(res)
        this.active = false
        this.btnCloseHidden = false
        this.closeLoading('update-payment-file-loading')
        this.$vs.notify({
          color: 'success',
          title: 'Success',
          text: 'File Updated'
        });
        this.$emit('success')

      }).catch( res => {
        this.btnCloseHidden = false
        this.showValidationErrors(res)
        this.closeLoading('update-payment-file-loading')
      })
     
    }
  },
  mixins: [loading],
  props:['expense']
}
</script>

<style>
</style>